'use client';

import { DATADOG_RUM_NAME, useConsent } from '@lichtblick/consent';
import { useTracker } from '@lichtblick/tracker';
import { type FC, useEffect, useEffectEvent } from 'react';

interface Props {
  flag: string;
  value: boolean;
}

export const FeatureFlagTracker: FC<Props> = ({ flag, value }) => {
  const datadogRumState = useConsent(DATADOG_RUM_NAME);
  const { trackCustomEvent } = useTracker();

  const trackVariant = useEffectEvent(() => {
    trackCustomEvent(
      {
        eventName: 'exp_impression',
        customProps: { exp_name: flag, exp_variant: value ? 'true' : 'false' },
      },
      undefined,
      true,
    );
  });

  useEffect(() => {
    if (!datadogRumState) {
      return;
    }

    import('@datadog/browser-rum').then(({ datadogRum }) => {
      datadogRum.onReady(() => {
        datadogRum.addFeatureFlagEvaluation(flag, value);

        datadogRum.setGlobalContextProperty('featureFlags', {
          ...(datadogRum.getGlobalContext().featureFlags as Record<string, boolean>),
          [flag]: value,
        });
      });
    });
  }, [datadogRumState, flag, value]);

  useEffect(() => {
    trackVariant();
  }, []);

  return null;
};
